<template>
	<div class="flex_1 margin_horizontal">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<div v-if="activeTab === tabTypes.upload" class="flex ">
			<card-list class="flex_1" @uploaded="updateCounts"></card-list>
		</div>
		<UpLoadTable v-if="activeTab && activeTab !== tabTypes.upload && activeTab !== tabTypes.receivables" :tabInfo="activeTab"></UpLoadTable>
    <ReceivableTableWithFilter v-if="activeTab === tabTypes.receivables"></ReceivableTableWithFilter>
	</div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

import CardList from "@/components/templates/seller/CardList.vue";
import UpLoadTable from "@/components/templates/seller/UpLoadTable.vue";

import {receivableApi} from "@/common/api/receivableApi";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import {hasAccess} from "@/common/permission/permission";

import ReceivableTableWithFilter from "@/components/templates/seller/receivables/ReceivableTableWithFilter";

export default {
	components: { AccessRestrictedTabs, CardList, UpLoadTable, ReceivableTableWithFilter },
	data() {
		let tabTypes = {
			upload: {
				name: navigationTabs.seller.upload.upload,
				translationKey: "seller.upload.Upload",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null
			},
			new: {
				name: navigationTabs.seller.upload.new,
				translationKey: "seller.upload.New",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null,
				dataApi: receivableApi.inspection.listNew
			},
			waiting: {
				name: navigationTabs.seller.upload.waiting,
				translationKey: "seller.upload.WaitingReview",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null,
				dataApi: receivableApi.inspection.listWaiting
			},
			rejected: {
				name: navigationTabs.seller.upload.rejected,
				translationKey: "seller.upload.Rejected",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null,
				dataApi: receivableApi.inspection.listDeclined
			},
      receivables: {
        name: navigationTabs.seller.upload.receivables,
        translationKey: "seller.upload.allReceivables",
        permission: enumDef.permissions.SellerSellReceivables
      }
		};

		return {
			tabTypes: tabTypes,
			activeTab: null,
		};
	},
	created() {
		this.updateCounts();
	},
	methods: {
		updateCounts() {
			if (hasAccess(this.currentUser, enumDef.permissions.SellerSellReceivables)) {
				receivableApi.inspection.counts()
					.then(counts => {
						this.tabTypes.new.count = counts.newCount;
						this.tabTypes.waiting.count = counts.waitingForReviewCount;
						this.tabTypes.rejected.count = counts.rejectedCount;
					});
			}
		},
	},
	computed: {
		...mapGetters({ tableData: "upTableData" })
	},
	watch: {
		tableData() {
			this.updateCounts();
		},
		activeTab() {
			this.$store.dispatch("setActionUpLoadTab", this.activeTab.name);
		}
	}
};
</script>